import Logout from "@/components/AdminNavbar/Logout";
import RoleChip from "@/components/AdminNavbar/RoleChip";
import BreadCrumb from "@/components/Breadcrumbs";

interface NavbarProps {
  breadcrumbs: { name: string; href: string }[];
}

function AdminNavbar({ breadcrumbs }: NavbarProps) {
  return (
    <div className="z-50 flex h-16 justify-between bg-white pl-6 pr-2 shadow">
      <div className="flex items-center gap-6">
        <BreadCrumb breadcrumbs={breadcrumbs} />
      </div>
      <div className="flex items-center gap-5">
        <RoleChip />
        <Logout />
      </div>
    </div>
  );
}

export default AdminNavbar;
